export enum FunderApprovalRejectedPermissions {
  ViewInstruments = 'view_documents',
  ViewInstrumentDetails = 'view_instrument_details',
  EditInstrument = 'edit_instrument',
  ViewInstrumentAttachments = 'view_instrument_attachments',
  UndoRejection = 'undo_rejection',
}
